<div class="card-header">
  <app-breadcrumb currentPage="Categorieen"></app-breadcrumb>
</div>
<div class="card-body">
<div *ngIf="!isLoading">
  <div *ngIf="!showAdd">
    <button class="btn float-right" (click)="showAddForm()">categorie aanmaken</button>
    <div class="clearFix"></div>
    <table *ngIf="categories" class="table table-hover">
      <tbody *ngFor="let cat of categories; let i = id;">
        <tr *ngIf="selectedCategory.id!=cat.id">
          <td>
            {{cat.name}}
          </td>
          <td class="text-right">
            <mat-icon (click)="getSubcategories(cat)" class="pointer">keyboard_arrow_down</mat-icon>
          </td>
        </tr>


        <tr *ngIf="subcategories && selectedCategory.id==cat.id">
          <td colspan="2">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>{{cat.name}}</th>
                  <th class="text-right">
                    <mat-icon *ngIf="subcategories" (click)="hideSubcategory()" class="pointer">keyboard_arrow_up</mat-icon>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let scat of subcategories; let i = id;">
                  <td class="pl100">
                    {{scat.name}}
                  </td>

                  <td class="text-right pr100">
                    <mat-icon *ngIf="scat.mutable" (click)="deleteSubcategory(cat,scat.id)" class="pointer">close</mat-icon>
                  </td>
                </tr>
                <tr>
                  <td class="pl100">
                    <input [(ngModel)]="newName" placeholder="naam' | translate}}"
                      required>
                  </td>
                  <td class="w-155">
                    <button class="btn float-right" (click)="addSubcategory(cat,newName)">subcategorie aanmaken</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
</div>
